import toastr from '@/common/services/toastr'

import AppDispatch from './pages/AppDispatch/index'
import Dashboard from './pages/Dashboard/index'

import Estimate from './pages/Order/Estimate/index'
import Reload from './pages/Order/Reload/index'
import Request from './pages/Order/Request/index'

import ListEstimated from './pages/List/Estimated'
import ListSettled from './pages/List/Settled'
import ListArranged from './pages/List/Arranged'
import ListCompleted from './pages/List/Completed'
import ListSearch from './pages/List/Search'

import Customer from './pages/Customer'

import Calc from './pages/Calc'

import Fabric from './pages/Fabric'

export default [
  {
    path: '/',
    redirect: '/app_dispatch'
  },
  {
    path: '/app_dispatch',
    name: 'app_dispatch',
    component: AppDispatch,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      requiresRoles: ['basic']
    }
  },
  {
    path: '/order/estimate',
    name: 'order_estimate',
    component: Estimate,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/order/estimate/:token',
    name: 'order_edit',
    component: Estimate,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/order/reload/:token',
    name: 'order_reload',
    beforeEnter: (to, from, next) => {
      if (from.name !== 'order_edit' && from.name !== 'order_estimate') {
        toastr.warning('不正な遷移です。トップページに遷移します。')
        next('/')
      }
      next()
    },
    component: Reload,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/request',
    name: 'request',
    component: Request,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/list/estimated',
    name: 'order_estimated',
    component: ListEstimated,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/list/settled',
    name: 'order_settled',
    component: ListSettled,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/list/arranged',
    name: 'order_arranged',
    component: ListArranged,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/list/completed',
    name: 'order_completed',
    component: ListCompleted,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/list/search',
    name: 'order_search',
    component: ListSearch,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/customer',
    name: 'customer',
    component: Customer,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/calc',
    name: 'calc',
    component: Calc,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  },
  {
    path: '/fabric',
    name: 'fabric',
    component: Fabric,
    meta: {
      requiresAuth: true,
      requiresRoles: ['user']
    }
  }
]



// WEBPACK FOOTER //
// ./src/app/routes.js